import AdminRedemptionsList from "./AdminRedemptionsList";
export default AdminRedemptionsList;
